<template>
  <div class="poster-container" :class="[position]">
    <img class="poster-image" :src="url" alt="" />
  </div>
</template>
<script>
export default {
  props: {
    position: {
      type: String,
      default: 'top'
    },
    zIndex: {
      type: Number | String,
      default: 2000
    },
    url: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.poster-container {
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  align-items: flex-start;
  justify-content: center;

  .poster-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.top {
  align-items: flex-start;
}

.center {
  align-items: center;
}
</style>
